import * as AdapterManager from '../../adapters/AdapterManager';
import ApiErrorCode from '../ApiErrorCode';
import getTokenForExtension from './getTokenForExtension';
import { ApiMethodCallback } from '../ApiMethod';
import { createErrorResult } from '../ApiMethodResponseCreator';
import { createTokenAsyncResult } from './TokenAsyncResult';
import { getAddinCommandForControl } from 'owa-addins-store';
import { RestTokenType, ScopedTokenType } from '../../services/getClientAccessToken';

export interface GetCallbackTokenArgs {
    isRest: boolean;
}

export default async function getCallbackTokenApiMethod(
    hostItemIndex: string,
    controlId: string,
    data: GetCallbackTokenArgs,
    callback: ApiMethodCallback
): Promise<void> {
    const addinCommand = getAddinCommandForControl(controlId);
    const scope = createScopeForItem(hostItemIndex);
    const tokenType = data.isRest ? RestTokenType : ScopedTokenType;

    if (!scope) {
        callback(createErrorResult(ApiErrorCode.CallSaveAsyncBeforeToken));
        return;
    }

    const token = await getTokenForExtension(addinCommand, tokenType, scope);

    if (token) {
        callback(createTokenAsyncResult(/* wasSuccessful*/ true, token.TokenValue));
    } else {
        callback(createErrorResult(ApiErrorCode.GenericTokenError));
    }
}

export const ParentItemIdPrefix = 'ParentItemId:';

function createScopeForItem(hostItemIndex: string) {
    const adapter = AdapterManager.getAdapter(hostItemIndex);
    const itemId = adapter.getItemId();

    if (!itemId) {
        return null;
    }

    return ParentItemIdPrefix + itemId;
}
